module.exports = __webpack_public_path__ + "static/img/yanbao128.ba2552f.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/yanbao128.png
// module id = gAFI
// module chunks = 1